// extracted by mini-css-extract-plugin
export var root = "eb5583123436d0d77d5c19244634c5e3-css";